import { render, staticRenderFns } from "./npclist.vue?vue&type=template&id=e6f1cfdc&scoped=true&"
import script from "./npclist.vue?vue&type=script&lang=js&"
export * from "./npclist.vue?vue&type=script&lang=js&"
import style0 from "./npclist.vue?vue&type=style&index=0&id=e6f1cfdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f1cfdc",
  null
  
)

export default component.exports